import { Direction } from "@angular/cdk/bidi";
import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";

import { InputBoolean } from "ng-zorro-antd/core/util";
import { ɵNzSliderHandleComponent as NzSliderHandleComponent } from "ng-zorro-antd/slider";

import { UiSliderService } from "../../services/slider.service";
import { UiSliderShowTooltip } from "@webapp/ui/slider/models/slider.models";
import { UiTooltipDirective } from "@webapp/ui/tooltip/tooltip.directive";

@Component({
  selector: "ui-slider-handle",
  exportAs: "uiSliderHandle",
  templateUrl: "handle.component.html",
})
export class UiSliderHandleComponent extends NzSliderHandleComponent {
  @Input("uiVertical")
  public vertical?: boolean;
  @Input("uiReverse")
  public reverse?: boolean;
  @Input("uiOffset")
  public offset?: number;
  @Input("uiValue")
  public value?: number;
  @Input("uiTooltipVisible")
  public tooltipVisible: UiSliderShowTooltip = "default";
  @Input("uiTooltipPlacement")
  public tooltipPlacement?: string;
  @Input("uiTooltipFormatter")
  public tooltipFormatter?: null | ((value: number) => string);
  @Input("uiActive")
  @InputBoolean()
  public active = false;
  @Input("uiDir")
  public dir: Direction = "ltr";

  @ViewChild("handle", { static: false })
  public handleEl?: ElementRef;
  @ViewChild(UiTooltipDirective, { static: false })
  public tooltip?: UiTooltipDirective;

  constructor(sliderService: UiSliderService, cdr: ChangeDetectorRef) {
    super(sliderService, cdr);
  }
}
